import { UpgradeComponent } from '@angular/upgrade/static';
import {
    Directive,
    ElementRef,
    EventEmitter,
    Injector,
    Input,
    Output
} from '@angular/core';

@Directive({
    selector: 'pkp-paging-setting'
})
export class PagingSettingComponent extends UpgradeComponent {
    @Output() onChange;
    @Output() onInitializeFinished;

    @Input() cost;
    @Output() costChange = new EventEmitter();

    @Input() amount;
    @Output() amountChange = new EventEmitter();

    @Input() pageSize;
    @Output() pageSizeChange = new EventEmitter();

    constructor(elementRef: ElementRef, injector: Injector) {
        super('pkpPagingSetting', elementRef, injector);
    }
}
